import { deserializeUserData } from "deserializers/deserializeUserData"
import { useEffect } from "react"
import { useRecoilState, useSetRecoilState } from "recoil"
import { firebaseUserState } from "recoils/firebaseUserState"
import { auth, initFirebaseAuth } from "usecases/firebase/auth"

import type { UserDataIF } from "interfaces/UserDataIF"
import type { CurrentUserType } from "usecases/firebase/auth"

export const useInitializeFirebaseAuth = (): UserDataIF => {
  const fbAuth = initFirebaseAuth()
  const [user, setUser] = useRecoilState(firebaseUserState)

  const setUserData = (user: CurrentUserType) =>
    setUser(deserializeUserData(user))

  useEffect(() => {
    fbAuth
      .then((currentUser) => {
        setUserData(currentUser)
      })
      .catch((error) => {
        console.log(error)
      })
  }, [])

  return user
}

export const useReloadFirebaseAuth = () => {
  const setUser = useSetRecoilState(firebaseUserState)

  return () => {
    if (auth.currentUser) {
      return auth.currentUser.reload().then(() => {
        setUser(deserializeUserData(auth.currentUser))
      })
    } else {
      return new Promise<void>(() => {
        setUser(deserializeUserData(null))
      })
    }
  }
}
